import URLs from '@/scripts/request/URLs';
import type { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import { myClientStorage } from '@/scripts/utils';
import { MyError } from '@/scripts/extends';
import { userApis } from '../user';
import type { UserKeyPackageType } from '../type';

export const commonApis = {
  getSocket() {
    const token = userApis.getToken();
    if (token) {
      return new WebSocket(new URLs.WS('/api/v1/ws', { token }));
    }
  },
  getSequence(type: ChatCategory, serverSequence?: number) {
    return myClientStorage
      .getItem<number>('sequence_' + type)
      .then((sequence) => sequence || 0)
      .then((sequence) => {
        if (serverSequence === undefined || sequence < serverSequence) {
          return sequence;
        }
        throw new MyError({
          message: 'Sequence is old.',
          code: 'SEQUENCE_IS_OLD',
        });
      });
  },
  setSequence(type: ChatCategory, sequence: number) {
    return myClientStorage.setItem('sequence_' + type, sequence);
  },
  setUserPackage({
    version,
    type,
    userId,
    keyPackage,
  }: {
    version: string;
    type: UserKeyPackageType;
    userId: string;
    keyPackage: string;
  }) {
    return myClientStorage.setItem(
      `UPLOAD_USER_KEY_V${version}_${type}_${userId}`,
      keyPackage
    );
  },
  getUserPackage({
    version,
    type,
    userId,
  }: {
    version: string;
    type: UserKeyPackageType;
    userId: string;
  }) {
    return myClientStorage.getItem<string>(
      `UPLOAD_USER_KEY_V${version}_${type}_${userId}`
    );
  },
  setInitCrypto(isInit: boolean) {
    return myClientStorage.setItem('initCrypto', isInit);
  },
  getInitCrypto() {
    return myClientStorage.getItem('initCrypto');
  },
};
